import type { MinCopy } from '@/i18n/types'

export function localizedAchievementTitle(
  titles: MinCopy['achievementTitles'],
  code: string,
  fallback: string,
): string {
  return titles[code as keyof MinCopy['achievementTitles']] ?? fallback
}
